'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require ('materialize-css');

import swal from 'sweetalert';
//importarScript("js/swal.js");

const flashcanvas = require('./flashcanvas');
const jSignature = require('./jSignature.min');
var contLogin,campo,emailRegex;
var $sigdiv;
var signatureValidation;

function importarScript(nombre) {
    var s = document.createElement("script");
    s.src = https + nombre;
    document.querySelector("head").appendChild(s);
}

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
            $('#modalLogin').modal('open');
        },0);
    }
    window.load = cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
    $sigdiv = $("#signature");
    $sigdiv.jSignature();
    var datapair = $sigdiv.jSignature("getData","default");
    signatureValidation = datapair.replace(/^data\:image\/\w+\;base64\,/, '');
});

/*$("#modal_promocion").click(function () {
    $("#modal_promocion").modal('close');
});*/

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$(window).scroll(function() {
    if($(window).width() < 600) {
        if ($(document).scrollTop() > 80) {
            $('#wpFloat').css('display','block');
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=75){
                $('#wpFloat').css('display','none');
            }
        }
    }
});

$('.reset').click(function () {
    $sigdiv.jSignature("reset");
    $('[name=signature]').val('');
});

$('.submitSignature').click(function () {
    var datapair = $sigdiv.jSignature("getData","default");
    $('[name=signature]').val(datapair.replace(/^data\:image\/\w+\;base64\,/, ''));
    setTimeout(function () {
        $('#formSignature').submit();
    },100);
});

$('#formSignature').on('submit',function (e) {
    e.preventDefault();

    var data = $(this).serialize();

    if( !$('#autorize').prop('checked') ) {
        swal({
            text: "Debe autorizarnos",
            icon: imageURL,
            button: false,
        });
        return false;
    }

    if( $('[name=signature]').val() == '' ){
        swal({
            text: "Debe digitar su firma",
            icon: imageURL,
            button: false,
        });
        return false;
    }

    /*if( $('[name=signature]').val() == 'iVBORw0KGgoAAAANSUhEUgAAAbMAAABtCAYAAAArro9sAAAEX0lEQVR4Xu3XgQ3DMAwDQXezdPJmtI5hvHRdIOZRANHP8SNAgAABAnGBT/z9nk+AAAECBI4xcwQECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAsbMDRAgQIBAXsCY5SsUgAABAgSMmRsgQIAAgbyAMctXKAABAgQIGDM3QIAAAQJ5AWOWr1AAAgQIEDBmboAAAQIE8gLGLF+hAAQIECBgzNwAAQIECOQFjFm+QgEIECBAwJi5AQIECBDICxizfIUCECBAgIAxcwMECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAsbMDRAgQIBAXsCY5SsUgAABAgSMmRsgQIAAgbyAMctXKAABAgQIGDM3QIAAAQJ5AWOWr1AAAgQIEDBmboAAAQIE8gLGLF+hAAQIECBgzNwAAQIECOQFjFm+QgEIECBAwJi5AQIECBDICxizfIUCECBAgIAxcwMECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAsbMDRAgQIBAXsCY5SsUgAABAgSMmRsgQIAAgbyAMctXKAABAgQIGDM3QIAAAQJ5AWOWr1AAAgQIEDBmboAAAQIE8gLGLF+hAAQIECBgzNwAAQIECOQFjFm+QgEIECBAwJi5AQIECBDICxizfIUCECBAgIAxcwMECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAsbMDRAgQIBAXsCY5SsUgAABAgSMmRsgQIAAgbyAMctXKAABAgQIGDM3QIAAAQJ5AWOWr1AAAgQIEDBmboAAAQIE8gLGLF+hAAQIECBgzNwAAQIECOQFjFm+QgEIECBAwJi5AQIECBDICxizfIUCECBAgIAxcwMECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAsbMDRAgQIBAXsCY5SsUgAABAgSMmRsgQIAAgbyAMctXKAABAgQIGDM3QIAAAQJ5AWOWr1AAAgQIEDBmboAAAQIE8gLGLF+hAAQIECBgzNwAAQIECOQFjFm+QgEIECBAwJi5AQIECBDICxizfIUCECBAgIAxcwMECBAgkBcwZvkKBSBAgAABY+YGCBAgQCAvYMzyFQpAgAABAtfH7Hme3znnUQUBAgQIZAXe932/N19vzG7q+zYBAgRmCBizGT1KQYAAAQI3Ba7/M7sZ3rcJECBAYIaAMZvRoxQECBBYLWDMVtcvPAECBGYIGLMZPUpBgACB1QLGbHX9whMgQGCGgDGb0aMUBAgQWC1gzFbXLzwBAgRmCBizGT1KQYAAgdUCxmx1/cITIEBghoAxm9GjFAQIEFgtYMxW1y88AQIEZggYsxk9SkGAAIHVAsZsdf3CEyBAYIaAMZvRoxQECBBYLWDMVtcvPAECBGYIGLMZPUpBgACB1QLGbHX9whMgQGCGgDGb0aMUBAgQWC1gzFbXLzwBAgRmCBizGT1KQYAAgdUCf+P/Cm4Ks288AAAAAElFTkSuQmCC')
    {
        swal({
            text: "Debe digitar su firma",
            icon: imageURL,
            button: false,
        });
        return false;
    }

    if( $('[name=signature]').val() == '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')
    {
        swal({
            text: "Debe digitar su firma",
            icon: imageURL,
            button: false,
        });
        return false;
    }*/

    if( $('[name=signature]').val() == signatureValidation){
        swal({
            text: "Debe digitar su firma",
            icon: imageURL,
            button: false,
        });
        return false;
    }

    swal({
        text: "Estamos validando, espere un momento ...",
        icon: imageURL,
        button: false,
    });

    $.ajax({
        url: https + "signatureRegister",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formSignature")[0].reset();
                swal.close();
                swal({
                    text: "¡Firma enviada con exito!",
                    icon: imageURL,
                    button: "OK!",
                });
                setTimeout(function () {
                    location.reload()
                },1000);
            }else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

$('.btnFormLogin').on('click',function () {
    Login();
});

function Login() {
    $('#user').removeClass('error');
    $('#pass').removeClass('error');
    var contLogin = 1;
    if ($.trim($("#user").val()) == "" ) {
        contLogin = 0;
        $('#user').addClass('error');
    }

    if ($.trim($("#pass").val()) == "" ) {
        contLogin = 0;
        $('#pass').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    var email = $('#user').val();
    var password = $('#pass').val();

    $.ajax({
        type: "post",
        url: https + "loginSignature",
        data: {
            user: email,
            pass: password
        },
        success: function (data) {
            if ($.trim(data) == "1") {
                $('#modalLogin').modal('close');
                getDatos();
            } else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
}

function getDatos()
{
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });
    $.ajax({
        url: https + "getDatos",
        type: "POST",
        dataType: "json",
        data:{id:1,action:'getDatos'},
        success:function(datos){
            if(datos == '0'){
                swal({
                    text: "Usted no posee permisos para proceder",
                    icon: imageURL,
                    button: false,
                });
                location.reload();
            }else{
                swal.close();
                $('.filled-in').prop('checked', false);
                $('#tarjet_'+datos.type_tarjet).prop('checked', true);
                $('#name').val(datos.name);
                $('#number_tarjet').val(datos.number_tarjet);
                $('#expiration_date').val(datos.expiration_date);
                $('#amount').val(datos.amount);
                $('#billing_adress').val(datos.billing_adress);
                $('#phone').val(datos.phone);
                $('#description').html(datos.description);
            }
        }
    });
}